import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {Bindings} from "data/constants/bindings";
import type {IBrazeApiProvider} from "data/providers/api/braze.api.provider";

export interface IBrazeStore extends ViewController {
	get preferenceUrl(): string;
	trackUser: () => Promise<void>;
	fetchPreferenceUrl: () => Promise<void>;
}

export type TBrazeResponse = {
	success: {
		result: string;
	};
};
@injectable()
export class BrazeStore implements IBrazeStore {
	constructor(@inject(Bindings.BrazeApiProvider) private _brazeProvider: IBrazeApiProvider) {
		makeAutoObservable(this);
	}
	@observable private _preferenceUrl: string = "";

	get preferenceUrl(): string {
		return this._preferenceUrl;
	}
	// async trackUser() {
	// 	await this._brazeProvider.startTracking();
	// }
	// async fetchPreferenceUrl() {
	// 	const response = await this._brazeProvider.preferenceUrl();
	// 	this._preferenceUrl = response?.data?.success?.result;
	// }

	async trackUser() {
		await this.safeAsync(
			() => this._brazeProvider.startTracking(),
			"Braze startTracking failed:"
		);
	}

	async fetchPreferenceUrl() {
		const response = await this.safeAsync(
			() => this._brazeProvider.preferenceUrl(),
			"Failed to fetch preference URL:"
		);

		this._preferenceUrl = response?.data?.success?.result ?? "";
	}

	private async safeAsync<T>(fn: () => Promise<T>, errorMessage: string): Promise<T | null> {
		try {
			return await fn();
		} catch (error) {
			console.error(errorMessage, error);
			return null;
		}
	}
}
